export const DEFAULT_LOCALE = "en";
export const FALLBACK_LOCALE = "en";
export const SUPPORTED_LOCALES = "en.cz";
